import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import Link from 'next/link';
import Image from 'next/image';
import Col100 from '@@client/components/Col100';
export default function OurStuff() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-1313314216" + " " + 'a-sm',
      children: /*#__PURE__*/_jsx(Col100, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "jsx-1313314216" + " " + 'items',
          children: [/*#__PURE__*/_jsx(Link, {
            href: "/about",
            children: /*#__PURE__*/_jsxs("a", {
              className: "jsx-1313314216" + " " + 'item m--lift-hover',
              children: [/*#__PURE__*/_jsx("div", {
                className: "jsx-1313314216" + " " + 'm--bg--img',
                children: /*#__PURE__*/_jsx(Image, {
                  layout: "fill",
                  src: "/images/content/bandr-storefront.png",
                  alt: "B&R store front"
                })
              }), /*#__PURE__*/_jsx("h3", {
                className: "jsx-1313314216",
                children: "Our Story"
              })]
            })
          }), /*#__PURE__*/_jsx(Link, {
            href: "/resources/warranties",
            children: /*#__PURE__*/_jsxs("a", {
              className: "jsx-1313314216" + " " + 'item m--lift-hover',
              children: [/*#__PURE__*/_jsx("div", {
                className: "jsx-1313314216" + " " + 'm--bg--img',
                children: /*#__PURE__*/_jsx(Image, {
                  layout: "fill",
                  src: "/images/content/man-walking-down-aisle-of-parts--985x550.png",
                  alt: "man walking down aisle of car parts"
                })
              }), /*#__PURE__*/_jsx("h3", {
                className: "jsx-1313314216",
                children: "Our Warranty"
              })]
            })
          }), /*#__PURE__*/_jsx(Link, {
            href: "/about/videos",
            children: /*#__PURE__*/_jsxs("a", {
              className: "jsx-1313314216" + " " + 'item m--lift-hover',
              children: [/*#__PURE__*/_jsx("div", {
                className: "jsx-1313314216" + " " + 'm--bg--img',
                children: /*#__PURE__*/_jsx(Image, {
                  layout: "fill",
                  src: "/images/content/man-holding-part.png",
                  alt: "man holding a car part"
                })
              }), /*#__PURE__*/_jsx("h3", {
                className: "jsx-1313314216",
                children: "Our Inspection Process"
              })]
            })
          }), /*#__PURE__*/_jsx(Link, {
            href: "/blog",
            children: /*#__PURE__*/_jsxs("a", {
              className: "jsx-1313314216" + " " + 'item m--lift-hover',
              children: [/*#__PURE__*/_jsx("div", {
                className: "jsx-1313314216" + " " + 'm--bg--img',
                children: /*#__PURE__*/_jsx(Image, {
                  layout: "fill",
                  src: "/images/content/dodge-truck-closeup.png",
                  alt: "dodge truck closeup"
                })
              }), /*#__PURE__*/_jsx("h3", {
                className: "jsx-1313314216",
                children: "Our Blog"
              })]
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1313314216",
      children: [".items.jsx-1313314216{display:grid;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat(2,1fr);grid-gap:30px;}", "@media(min-width:992px){.items.jsx-1313314216{grid-template-rows:unset;grid-template-columns:repeat(4,1fr);}}", ".item.jsx-1313314216{display:block;-webkit-text-decoration:none;text-decoration:none;padding:36px;}", "@media(min-width:576px){.item.jsx-1313314216{min-height:258px;}}", "@media(min-width:768px){.item.jsx-1313314216{min-height:258px;}}", "@media(min-width:992px){.item.jsx-1313314216{min-height:199px;}}", "@media(min-width:1200px){.item.jsx-1313314216{min-height:269px;}}", ".item.jsx-1313314216::after{content:'';display:block;position:absolute;z-index:-1;left:18px;right:18px;top:18px;bottom:18px;background:-webkit-gradient(linear,left top,left bottom,from(#1C357D),to(#182661));background:linear-gradient(#1C357D,#182661);opacity:0.42;}", "h3.jsx-1313314216{color:white;font-family:\"Cubano\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:1.6875rem;margin:0;line-height:1.05;}", "@media(min-width:1200px){h3.jsx-1313314216{font-size:2.375rem;}}"]
    })]
  });
}